import { render, staticRenderFns } from "./ktj.vue?vue&type=template&id=5182ca77&scoped=true"
import script from "./ktj.vue?vue&type=script&lang=js"
export * from "./ktj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5182ca77",
  null
  
)

export default component.exports